module.exports = __webpack_public_path__ + "img/Wasserrettungsgruppe.1de3aca2.svg";